<template>
  <div class="u-select useral-custom-element-select" :class="classes" :tabindex="tabindex" v-click-outside="handleClickOutside">
<!--    <label v-if="label">{{ label }}</label>-->
    <div class="u-select-label-box" :class="[{'u-select-open': open && hasDropdownList, 'clickable': clickable, 'danger': danger, 'disabled': disabled || !hasDropdownList}, `u-select-position-${selectOpenPosition}`]">
      <div class="u-select-label-box-start"></div>
      <div v-if="label" class="u-select-label-box-center" :class="[labelPosition]">
        <span class="u-select-label text-subtitle" :class="[{'text-body-1': labelPosition === 'inside'}]">{{ label }}</span>
      </div>
      <div class="u-select-label-box-end"></div>
    </div>
    <div class="u-selected-item" :class="{ 'open': open, 'disabled': disabled || !hasDropdownList }" :style="styles" @click="setSelectOpenPosition">

      <vs-icon class="u-select-clear-search"
               icon="icon-x"
               icon-pack="feather"
               v-if="searchable && search && !disabled"
               @click="search = ''"/>

      <input v-if="searchable"
             type="text"
             class="useral-custom-element-input w-full"
             :autocomplete="'new-password'"
             :name="Math.random()"
             :disabled="disabled"
             @input="$emit('searched', $event)"
             v-model="search">

      <div @click=""
           v-else>
        {{ typeof selected === 'string' ? JSON.parse(selected).label : selected.label }}
      </div>
    </div>

    <div v-show="hasDropdownList" class="u-select-items" :class="[{ 'u-select-hide': !open }, `position-${selectOpenPosition}`]" :style="{maxHeight: `${listMaxHeight}px`}">
      <template v-for="(option, i) of options">
        <div
          :key="i"
          class="select-item"
          :class="{disabled: option.disabled}"
          v-show="(!option.hasOwnProperty('show') || option.show) && selected.value !== option.value"
          @click="handleSelectOption(option)">
          {{ typeof option === 'string' ? JSON.parse(option).label : option.label }}
          <span v-if="option.badge" class="select-badge" :class="option.badge.class">
          {{ option.badge.value }}
        </span>
        </div>
      </template>
    </div>

    <div class="custom-select-overflow" v-if="open && hasBackdropOverflow" @click="open = false"></div>
  </div>
</template>

<script>
export default {
  name: 'customSelect',
  data () {
    return {
      firstVisit: true,
      firstVisitTimer: 0,
      selected: this.default ? this.default : this.options.length > 0 ? this.options[0] : null,
      open: false,
      selectOpenPosition: 'bottom',
      search: '',
      listMaxHeight: 150
    }
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: () => ''
    },
    labelPosition: {
      type: String,
      default: 'outline',
      validator (value) {
        return ['outline', 'outside'].includes(value)
      }
    },
    clickable: {
      type: Boolean,
      default: () => { return false }
    },
    setPageChange: {
      type: Boolean,
      default: () => { return true }
    },
    classes: {
      type: Array,
      default: () => []
    },

    styles: {
      type: String,
      default: () => ''
    },
    default: {
      type: [Object, String],
      default: () => { return {} }
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    searchable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    hasBackdropOverflow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDropdownList () {
      let listCount = 0
      this.options.forEach(option => {
        if ((!option.hasOwnProperty('show') || option.show) && this.selected.value !== option.value) {
          listCount++
        }
      })
      return listCount > 0
    }
  },
  mounted () {
    // this.$emit("input", this.selected);
    this.search = this.selected.label === '-' ? '' : this.selected.label
    if (this.default) this.search = this.default.label === '-' ? '' : this.default.label
  },
  methods: {
    setSelectOpenPosition () {
      const modalEl = this.$el.closest('.prompt-content')
      let spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom
      let spaceTop = this.$el.getBoundingClientRect().top
      if (modalEl) {
        const modalRect = modalEl.getBoundingClientRect()
        const elementRect = this.$el.getBoundingClientRect()

        spaceBelow = modalRect.bottom - elementRect.bottom
        spaceTop = elementRect.top - modalRect.top
      }
      if (spaceBelow > 100) {
        this.selectOpenPosition = 'bottom'
        this.listMaxHeight = Math.min(spaceBelow - 20, 250)
      } else {
        this.selectOpenPosition = 'top'
        this.listMaxHeight = Math.min(spaceTop - 20, 250)
      }
      if (!this.disabled) {
        this.open = !this.open
      }
    },
    handleClickOutside () {
      if (this.open) {
        this.open = false
      }
    },
    handleSelectOption (option) {
      if (!option.disabled) {
        this.selected = option
        this.open = false
        if (this.setPageChange) {
          this.$store.dispatch('setPageChanges')
        }
        this.$emit('input', option)
        this.$emit('suggest:selected', option)
        this.search = option.label
      }
    }
  },
  watch: {
    default: {
      handler () {
        if (this.default && this.default.label !== '') {
          this.selected = this.default

          if (this.searchable) {
            this.search = this.default.label === '-' ? '' : this.default.label
          }
        }
      },
      deep: true
    },
    search: {
      handler (val) {
        if (this.searchable) {
          clearTimeout(this.firstVisitTimer)
          this.firstVisitTimer = setTimeout(() => {
            this.firstVisit = false
          }, 500)

          if (!this.firstVisit) {
            // this.open = true

            this.options.forEach((option) => {

              option.show = option.label.toString().toLowerCase().indexOf(val.toLowerCase()) !== -1
            })
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
/*@import "src/assets/scss/vuexy/variables";
.useral-custom-element-select {
  position: relative;
  width: 100%;
  min-width: 100px;
  text-align: left;
  outline: none;
  height: 35px;
  line-height: 35px;


  .selected {
    position: relative;
    border-radius: 0.5rem;
    min-height: 35px;
    line-height: 28px;
    color: #fff;
    background-color: transparent !important;
    border: 0 !important;
    padding: 0 5px;
    //text-align: center;
    cursor: pointer;
    user-select: none;
    z-index: unset !important;
    transition: background-color .3s ease;
    display: flex;
    align-items: center;

    & > div {
      width: 100%;
      z-index: 1;
    }

    input {
      padding-left: 20px !important;
      padding-right: 20px !important;
      transition: background-color .3s ease;
      line-height: 35px;
    }

    .cancel-search {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 7px;
      margin: auto;
      display: block;
      height: fit-content;
    }

    &.open {
      background-color: transparent;
      border-radius: .5rem .5rem 0 0 !important;
      border-bottom: 1px solid transparent !important;
      z-index: 200 !important;

      input {
        background-color: transparent !important;
      }
    }

    !*&.danger {
      border: 1px solid #b00000 !important;
    }*!
  }

  .selected:not(.disabled):before {
    position: absolute;
    content: "";
    top: calc(50% - 3px);
    right: 1em;
    width: 0;
    height: 0;
    border: 5px solid;
    border-color: $primary transparent transparent transparent;
  }

  .items {
    color: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    //border-right: 1px solid #10163a;
    //border-left: 1px solid #10163a;
    //border-bottom: 1px solid #10163a;
    position: absolute;
    background-color: #FFFFFF;
    left: 0;
    right: 0;
    z-index: 110000;
    //max-height: 250px;

    &::-webkit-scrollbar {
      display: block;
      border-radius: .5rem;
      width: 10px;
      background: #f9f9fd;
      right: 10px;
    }

    &::-webkit-scrollbar-thumb {
      display: block;
      border-radius: .2rem;
      background: #cecece;
    }

    &.position-bottom {
      //top: calc(100%);
      box-shadow: 0 5px 10px -5px $black-100 !important;
      border-radius: 0 0 0.5rem 0.5rem;
    }

    &.position-top {
      top: unset !important;
      bottom: calc(100% - 4px);
      border-radius: 0.5rem 0.5rem 0 0;
      box-shadow: 5px 0 10px -5px $black-100 !important;
    }

    div {
      color: $black-300;
      padding-left: 1em;
      cursor: pointer;
      user-select: none;
      border-top: 1px solid #cecece;
      font-size: 13px;
      height: 35px;
      line-height: 35px;
      box-sizing: content-box;
    }
  }

  .custom-select-overflow {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 10000;
  }
}

.selectHide {
  display: none;
}*/
</style>
